<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon account-icon"
        role="img">

    <!-- <svg :fill="fillColor"
         class="material-design-icon__svg"
         :width="size"
         :height="size"
         viewBox="0 0 24 24">
      <path d="M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z">
        <title>{{ title }}</title>
      </path>
    </svg> -->

    <svg class="material-design-icon__svg" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="30.56 28.32 26.658 23.121"><path :fill="fillColor" d="M50.082 46.996a.874.874 0 01-1.748 0v-1.785a.873.873 0 011.748 0v1.785zm-1.773-13.342h-8.856c0-.617-.004-1.229.002-1.84a1.69 1.69 0 01.063-.417c.199-.725.857-1.269 1.606-1.275 1.832-.014 3.665-.018 5.497 0 .916.009 1.655.76 1.685 1.678.018.613.003 1.227.003 1.854zm-8.891 13.334a.87.87 0 01-1.74 0v-1.783a.87.87 0 111.74 0v1.783zm17.785-9.781a3.525 3.525 0 00-3.537-3.54c-1.091-.003-2.182 0-3.272 0h-.292c0-.565.009-1.104-.002-1.644a4.74 4.74 0 00-.076-.868c-.365-1.681-1.784-2.821-3.52-2.829a539.827 539.827 0 00-5.247 0c-2.051.01-3.592 1.568-3.594 3.618v1.722c-.803 0-1.569-.006-2.335.002-.606.006-1.218-.014-1.819.053-1.556.176-2.935 1.705-2.941 3.274-.015 3.698-.007 7.395-.003 11.092.001.698.255 1.322.662 1.876.75 1.022 1.784 1.477 3.04 1.475 3.181-.005 6.362-.002 9.543-.002 3.239 0 6.479-.015 9.718.005 2.285.014 3.713-1.843 3.688-3.691-.044-3.514-.009-7.029-.013-10.543z"/></svg>

  </span>
</template>

<script>
export default {
  name: "ProfessionalExperienceIcon",
  props: {
    title: {
      type: String,
      default: "Professional Experience icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
